const DownNote = ({ text }) => {
  return (
    <div class="alert alert-primary" role="alert">
      {text}
    </div>
  );
};
export default DownNote;
